import * as React from 'react';
import { CartSlider, Cart } from '@grandvisionhq/carts-v2';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import 'motion/react';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../StepShipping/selectors.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { ImplicitTermsAndConditionsContainer } from '../../../StepShipping/containers/ImplicitTermsAndConditionsContainer.js';
import { ShippingMethods } from '../../../StepShipping/modules/ShippingMethods/layouts/ShippingMethods.js';
import '@grandvisionhq/common';
import '@grandvisionhq/locations';
import '../../../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../../../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import { Consents } from '../../Consents/layout/Consents.js';
import { ServiceStore } from '../../ServiceStore/layout/ServiceStore.js';
import '../../ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '../../../selectors.js';
import { ServiceStoreHeading } from '../../ServiceStore/layout/ServiceStoreHeading.js';
import { ExpressCheckoutFormContainer } from './ExpressCheckoutFormContainer/ExpressCheckoutFormContainer.js';

const ExpressCheckoutUI = ({ shippingMethodsAsides , isNearestPickup ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            expressShipmentMethodTitle: getLabel('checkout.express.shipment.method.title'),
            expressServiceStoreTitle: getLabel('checkout.express.serviceStore.title'),
            expressServiceStoreSubtitle: getLabel('checkout.express.serviceStore.subtitle')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-checkout-ui"
    }, /*#__PURE__*/ React.createElement(CartSlider, null, /*#__PURE__*/ React.createElement(Cart, null)), /*#__PURE__*/ React.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides
    }), isNearestPickup && /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, getLabel('checkout.summary.shipment.nearestPickup.message')), /*#__PURE__*/ React.createElement(ExpressCheckoutFormContainer, null), /*#__PURE__*/ React.createElement(ServiceStoreHeading, {
        title: labels.expressServiceStoreTitle,
        subtitle: labels.expressServiceStoreSubtitle,
        hideIcon: true
    }), /*#__PURE__*/ React.createElement(ServiceStore, null), /*#__PURE__*/ React.createElement(Consents, null), /*#__PURE__*/ React.createElement(ImplicitTermsAndConditionsContainer, null));
};

export { ExpressCheckoutUI };
//# sourceMappingURL=ExpressCheckoutUI.js.map
